import {MI} from "../init";
import {shuffleArray} from "../../framework/src/helpers";
import BoomSpinOption from "./BoomSpinOption";

/**
 * @constructor
 * @returns {AnimsBoomSpins}
 */
export default function AnimsBoomSpins() {

    this._starsCount = 3;

    /** @type {Array<MadnesObject>} */
    this._particles = [];

    /** @type {Game} */
    this._game;

    /** @type {GameAssets} */
    this._assets;

    /** @type {GameGroups} */
    this._groups;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds;

    /** @type {MadnesObject} */
    this._boomSpinsLabel;

    /** @type {BoomSpinOption} */
    this._chooseSingle;

    /** @type {BoomSpinOption} */
    this._chooseDouble;

    this._darkButton = false;

    /** @type {?MadnesTimer} */
    this._pulseTimer;

    /** @type {Function} */
    this._onChoose = function(bsOption) {};

    /** @type {?MadnesTimer} */
    this._timer;
};

/** @param {Function} func */
AnimsBoomSpins.prototype.setOnChoose = function(func) {
    this._onChoose = func;
};

/**
 * @param {Game} game
 */
AnimsBoomSpins.prototype.create = function(game) {

    this._game = game;

    this._sounds = game.sounds;
    this._assets = game.assets;
    this._groups = game.groups;

    this._createParticles();

    this._boomSpinsLabel = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 - 70, "bonus_atlas").setFrameName("boom");
    this._boomSpinsLabel.setAnchor(0.5, 0.5);

    var spins = MI.addImg(0, 120, "bonus_atlas").setFrameName("spins");
    spins.setAnchor(0.5, 0.5);
    this._boomSpinsLabel.addChild(spins);
    this._boomSpinsLabel.setVisible(false);

    this._pulseTimer = null;

    this._chooseSingle = new BoomSpinOption();
    this._chooseSingle.create("single");
    this._chooseSingle.setOnChoose(this._choose.bind(this));

    this._chooseDouble = new BoomSpinOption();
    this._chooseDouble.create("double");
    this._chooseDouble.setOnChoose(this._choose.bind(this));
};

/**
 * @param {BoomSpinOption} bsOption
 */
AnimsBoomSpins.prototype._choose = function(bsOption) {

    this._timer && this._timer.stop();
    this._timer = null;

    this._chooseSingle.setButtonDisabled(true);
    this._chooseDouble.setButtonDisabled(true);

    this._chooseSingle.setButtonTexture(false);
    this._chooseDouble.setButtonTexture(false);

    bsOption.setButtonTexture(true);

    this._stopBlinkButtons();

    this._sounds["bonus_pick"].play();

    this._onChoose(bsOption);
};

AnimsBoomSpins.prototype._startBlinkButtons = function() {
    var _self = this;

    this._pulseTimer = MI.createTimer().loop(function() {

        _self._darkButton = !_self._darkButton;

        _self._chooseDouble.setButtonTexture(_self._darkButton);
        _self._chooseSingle.setButtonTexture(_self._darkButton);

    }, 1000);
};

AnimsBoomSpins.prototype._stopBlinkButtons = function() {
    this._pulseTimer.stop();
};

AnimsBoomSpins.prototype._createParticles = function() {

    var ptclPos = [];

    ptclPos.push({ 'x': 460, 'y': 280 });
    ptclPos.push({ 'x': 470, 'y': 520 });
    ptclPos.push({ 'x': 790, 'y': 530 });
    ptclPos.push({ 'x': 800, 'y': 300 });
    ptclPos.push({ 'x': 640, 'y': 320 });
    ptclPos.push({ 'x': 640, 'y': 470 });

    ptclPos = shuffleArray(ptclPos);

    var particleFrameNames = MI.generateFrameNames("particles_", 0, 34, "", 5);
    var group = this._groups.get("group_bw_particles");

    for(var i = 0; i < ptclPos.length; i++) {

        var particles = MI.addImg(ptclPos[i]["x"], ptclPos[i]["y"], "particles_atlas");
        particles.setScale(1.8, 1.8);
        particles.setAnchor(0.5, 0.5);
        particles.createAnims();
        particles.anims.add("anim", particleFrameNames);

        particles.anims.addOnComplete(function() {
            this.setVisible(false);
        });
        particles.setVisible(false);
        group.add(particles);

        this._particles.push(particles);
    }
};

/**
 * @param {number} starsCount
 */
AnimsBoomSpins.prototype.play = function(starsCount) {

    var _self = this;

    // this._chooseSingle.setStarsCount(starsCount);
    // this._chooseDouble.setStarsCount(starsCount);

    MI.createTimer().add(function() {
        for(var i = 0; i < _self._particles.length; i++) {
            (function(i) {
                MI.createTimer().add(function() {
                    _self._particles[i].setVisible(true);
                    _self._particles[i].anims.play("anim", 26);
                }, i * 90);
            } (i));
        }
    }, 200);


    this._boomSpinsLabel.setScale(0.2, 0.2);
    this._boomSpinsLabel.setAlpha(0);

    this._boomSpinsLabel.setVisible(true);

    return new Promise(function(res) {

        MI.addTween().to(_self._boomSpinsLabel, { 'alpha': 1 }, {
            'duration': 400,
        });

        MI.addTween().to(_self._boomSpinsLabel, { 'x': 1, 'y': 1 }, {
            'scale': true,
            'duration': 400,
            'callback': function() {

                MI.addTween().to(_self._boomSpinsLabel, { 'x': 0.88, 'y': 0.88 }, {
                    'scale': true,
                    'duration':  400,
                    'yoyo': true,
                    'count': 1,
                    'callback': res
                });
            }
        });

    }).then(function() {

        _self._sounds["bonus_start"].play();

        _self._game.bonus.startPlayBonusBg();

        _self._sounds["audio_bonus_bg"].fadeToInit(1000);

        return new Promise(function(res) {

            // _self._chooseSingle.reinit();
            // _self._chooseDouble.reinit();
            // _self._chooseSingle.animSmoke();
            // _self._chooseDouble.animSmoke();
            // _self._chooseSingle.setButtonDisabled(true);
            // _self._chooseDouble.setButtonDisabled(true);

            MI.addTween().to(_self._boomSpinsLabel, { 'alpha': 0 }, {
                'duration': 400,
                'callback': res
            });

            // MI.addTween().to(_self._chooseSingle.getObject(), { 'alpha': 1 }, {
            // 	'duration': 1000,
            // 	'callback': res
            // });
            //
            // MI.addTween().to(_self._chooseSingle.getObject(), { 'x': 1, 'y': 1 }, {
            // 	'scale': true,
            // 	'duration': 1000,
            // });
            //
            // MI.addTween().to(_self._chooseDouble.getObject(), { 'alpha': 1 }, {
            // 	'duration': 1000,
            // });
            //
            // MI.addTween().to(_self._chooseDouble.getObject(), { 'x': 1, 'y': 1 }, {
            // 	'scale': true,
            // 	'duration': 1000,
            // });
        });
    })/*.then(function() {

		// _self._startTimer();
		//
		// _self._chooseSingle.setButtonDisabled(false);
		// _self._chooseDouble.setButtonDisabled(false);
		//
		// _self._startBlinkButtons();

	})*/;
};

AnimsBoomSpins.prototype._startTimer = function() {

    var _self = this;

    this._timer = MI.createTimer().add(function() {

        if(getRandomBoolean()) {
            _self._chooseSingle.choose();
        } else {
            _self._chooseDouble.choose();
        }
    }, 45000);
};

/**
 * @param {BoomSpinOption} selectedBsOption
 */
AnimsBoomSpins.prototype.hide = function(selectedBsOption) {

    var _self = this;

    return new Promise(function(res) {

        var fadeOutOption = selectedBsOption.type === "double" ? _self._chooseSingle : _self._chooseDouble;
        var fadeOutObject = fadeOutOption.getObject();

        fadeOutOption.stopTweens();

        MI.addTween().to(fadeOutObject, { 'alpha': 0 }, {
            'duration': 800,
            'callback': function() {
                fadeOutObject.setAlpha(1);
                fadeOutObject.setVisible(false);

            }
        });

        var selectedObject = selectedBsOption.getObject();

        MI.createTimer().add(function() {

            _self._sounds["bonus_end"].play();

            selectedBsOption.stopTweens();

            MI.addTween().to(selectedObject, { 'x': 0.1, 'y': 0.1 }, {
                'scale': true,
                'duration': 1200
            });

            MI.addTween().to(selectedObject, { 'angle': selectedBsOption.type === "double" ? -360 : 360 }, {
                'duration': 600,
                'count': 1
            });

            MI.addTween().to(selectedObject, { 'x': MI.getWi() / 2, 'y': MI.getHe(), 'alpha': 0 }, {
                'duration': 1200,
                'callback': function() {
                    selectedObject.setAlpha(1);
                    selectedObject.setVisible(false);

                    res();
                }
            });

        }, 2500);
    });
};